"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentPolicyDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.ConsentPolicyDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-consent-policy');
//# sourceMappingURL=index.js.map